export default "__VITE_ASSET__DJilrkln__"